import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'
import ArgosIcon from '../../Common/Icons/Argos'

const cn = bem({ prefix: 'lc-', block: 'avatar' })

class Avatar extends React.Component {
  static propTypes = {
    agentName: PropTypes.string,
    type: PropTypes.oneOf(['user', 'system', 'agent']).isRequired,
    className: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    style: PropTypes.object,
  }

  static defaultProps = {
    agentName: '',
    className: '',
    height: 30,
    width: 30,
    style: {},
  }

  render() {
    const { agentName, type, className, height, width, style } = this.props

    const agentInitial = agentName.charAt(0)

    return (
      <div className={`${cn()} ${className}`} data-test={cn()} style={{ width, height, ...style }}>
        <div className={cn('placeholder')}>
          {type === 'system' && <ArgosIcon className={cn('system-icon')} height={height} width={width} />}

          {type === 'agent' && (
            <span className={cn('agent-icon')} height={height} width={width}>
              {agentInitial}
            </span>
          )}
        </div>
      </div>
    )
  }
}

export default Avatar
